import {
    fetch_content_graphql,
    fetch_content_preview,
} from "../../actions/Content/dispatchers";
import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { fetch_supplementary_data } from "../../actions/RightRail/dispatchers";
import { setAppState, setAppError } from "../../actions/App/dispatchers";
import { fetch_tracking } from "../../actions/Tracking/dispatchers";
import { page_initial_data } from "../../reducers/Page/reducer";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import swimlaneList from "../../actions/SwimlaneList/actions";
import { fetchVideoByLineup } from "../../actions/VideoCuratedPlaylist/dispatcher";

import { NEWS_PLAYLIST_VIDEO_SLUG } from "./constants";
import { WEB_AB_TESTS_URL } from "./constants";

import { fetch_widgets_content } from "../Landing/initData";
import log from "../../utils/logger/library";
import { requestJSON } from "../../utils/promises/library";
import { getIsMetaPreview } from "../../utils/page/library";

export const fetchLandingNewsPageData =
    (path, params, abortObject) => (dispatch) => {
        let url = path.slice(1);
        const isPreview = getIsMetaPreview(path);
        let previewId;

        if (isPreview) {
            url = path
                .replace("/meta/preview/", "")
                .replace(`/${params.contentId}`, "");
            path = path
                .replace("/meta/preview", "")
                .replace(`/${params.contentId}`, "");
            previewId = params.contentId;
        }

        dispatch(reset_app_state(path));
        dispatch(reset_right_rail());

        const mainContent = !isPreview
            ? dispatch(
                  fetch_content_graphql({
                      section: url,
                      abTestSlug: params.abTestSlug,
                  })
              )
            : dispatch(fetch_content_preview({ section: url, previewId }));
        return mainContent
            .then(() => {
                if (abortObject?.current) {
                    return Promise.resolve();
                }
                return Promise.all([
                    dispatch(fetch_tracking()),
                    dispatch(fetch_widgets_content(url)),
                    dispatch(fetch_supplementary_data(url)),
                    path === "/news" &&
                        dispatch(
                            fetchVideoByLineup(NEWS_PLAYLIST_VIDEO_SLUG, path)
                        ),
                    dispatch(page_initial_data({})),
                    dispatch(swimlaneList(url)),
                ])
                    .then(() => {
                        dispatch(setAppState(path, false, ""));
                    })
                    .catch((error) => {
                        log.error("(fetchLandingNewsPageData)", error);
                    });
            })
            .catch((error) => {
                dispatch(setAppError(path, error.code));
            });
    };

const getABTestName = (region) => {
    return `lineup-optimization-${region}`;
};

export const fetchABTestsConfigData = async (region) => {
    let abTest = null;
    try {
        const { tests } = await requestJSON(WEB_AB_TESTS_URL);
        abTest = tests[getABTestName(region)] || null;
    } catch (error) {
        log.error("(fetchABTestsConfigData)", error);
    }
    return abTest;
};
